export default __webpack_public_path__ + "static/media/nft-6.068e054c.gif";